import { render, staticRenderFns } from "./DidController.vue?vue&type=template&id=53112923&scoped=true&"
import script from "./DidController.vue?vue&type=script&lang=js&"
export * from "./DidController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53112923",
  null
  
)

export default component.exports